import React from 'react'
import styled from 'styled-components'
import { TopNavLinkListItem } from './TopNavLinkListItem'
import { TopNavLink } from './TopNavLink'
import { PageRoutes } from '../constants/PageRoutes'
import { SCREEN_SIZE, STYLES } from '../../static/style'
import { TopNavColor } from './TopNav.types'
import { TopNavDropdown } from './TopNavDropdown'

type TopNavLinkListProp = {
  color: TopNavColor
}

const StyledTopNavLinkList = styled.div`
  flex: 1;
  padding: 0 2rem;
  display: none;
  height: 100%;
  ${SCREEN_SIZE.MD} {
    display: block;
  }
`

export const TopNavLinkList = ({ color }: TopNavLinkListProp) => (
  <StyledTopNavLinkList>
    <TopNavLinkListItem>
      <TopNavLink color={color} to={PageRoutes.BLOG}>
        Blog
      </TopNavLink>
      <TopNavDropdown
        color={color}
        title="Advertise"
        items={[
          {
            to: PageRoutes.ADVERTISE_BASIC_SCHOOL_PLAN,
            text: 'Advertise for schools',
          },
          {
            to: PageRoutes.ADVERTISE_BASIC_ACTIVITY_PLAN,
            text: 'Advertise for activities',
          },
        ]}
      />
      <TopNavLink color={color} to={PageRoutes.DEVELOPERS}>
        Developers
      </TopNavLink>
    </TopNavLinkListItem>
  </StyledTopNavLinkList>
)
